import { Component, inject, signal } from '@angular/core';
import { SponserService } from '../../sponsor/Services/sponser.service';
import { SubSocietyModel } from '../Model/sponser.model';
import { SubSocietyService } from '../Services/sponser.service';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/Module/shared.module';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { ProfilePageRoutingModule } from "../../../pages/my-account/profile-page-routing.module";
import { RouterModule } from '@angular/router';
import { AdsComponent } from "../../../shared/Componet/ads/ads.component";
import { AnnouncementService } from '../../../shared/service/announcement.service';
import { AdsService } from '../../../shared/service/ads.service';

@Component({
  selector: 'app-feature',
  imports: [CommonModule, SharedModule, TranslateModule, ProfilePageRoutingModule, RouterModule, AdsComponent],
  templateUrl: './feature.component.html',
  styleUrl: './feature.component.css'
})
export class FeatureComponent {

  subSociety = signal<SubSocietyModel[]>([]);
  private subs = new Subscription();   // container for all subscriptions
  Announcements = signal<any[]>([])


  private subSocietyService = inject(SubSocietyService)
  private AnnouncementService = inject(AnnouncementService)
  private AdsService = inject(AdsService)

  ngOnInit(): void {
    this.loadData()
    this.getAnnouncemnts()
  }

  loadData(): void {
    const sub = this.subSocietyService.getAll().subscribe({
      next: (data) => {
        const sortedData = data.value.map(item => {
          if (item.subSocietyItems?.length > 0) {
            item.subSocietyItems = item.subSocietyItems.sort((a, b) => a.displayOrder - b.displayOrder);
          }
          return item;
        });

        this.subSociety.set(sortedData);

      },
      error: (err) => {
        console.error('Error loading sliders:', err);
      }
    });
    this.subs.add(sub);
  }

  getAnnouncemnts() {
    const sub = this.AnnouncementService.getDetectedAnnouncements({
      PageId: 6,
      SectionId: 7
    }).subscribe({
      next: (res: any) => {
        // this.Announcements.set(res.value)
        this.Announcements.set(this.AdsService.getDisplayedAds(res.value, 3));
      }
    })

    this.subs.add(sub);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();   // unsubscribe from all
  }
}
